/**************************************************
 * Nombre:       Recibo_Portada.js
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Button, Grid, Typography} from "@mui/material";
import {useContext, useEffect} from "react";
import {contexApp} from "../../../App";
import {useResponsive} from "../../../Modulo_responsive/Hooks/useResponsive";
import {theme} from "../../../Tema";
import {PDFDownloadLink} from "@react-pdf/renderer";
import logo from "../../../Recursos/icono_foto.png"
import Pdf_Recibo from "../../../Modulo_Recibo/Pdfs/Pdf_Recibo";


const Recibo_Portada = ({pago, pedido}) => {
    const cData = useContext(contexApp)
    const {sCell} = useResponsive()

    useEffect(() => {


    }, [cData]);
    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{
                backgroundColor: '#EAEEF0',
            }}
        >

            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 6}}
                sx={{maxWidth: '1400px', px: 3, pt: 6, pb: 3, color: theme.palette.primary.main}}
            >


                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center'}}>
                    <Typography sx={{fontSize: 16, fontWeight: 600}}>Recibo de compra</Typography>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center'}}>
                    <Typography sx={{fontSize: 40, fontWeight: 600, lineHeight: 1, textAlign: 'center'}}>Tu pedido está
                        en buenas manos, tu pago a sido <span
                            style={{fontWeight: 800}}>{pago.estado}</span></Typography>
                </Grid>


                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', mt: 4}}>
                    <Typography sx={{fontSize: 16, fontWeight: 400, textAlign: 'center'}}>
                        {pago.detalle}
                    </Typography>
                </Grid>


                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', mt: 4}}>
                    <Typography sx={{fontSize: 16, fontWeight: 400, textAlign: 'center'}}>
                        Gracias por elegir Generación Mezcal. Estamos preparando tu envío con el mismo rigor y cuidado
                        con el que supervisamos nuestra destilación. Gracias a nuestra tecnología de trazabilidad y
                        logística, recibirás la esencia pura de Oaxaca con la puntualidad y calidad que mereces.
                    </Typography>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', mt: 4, mb: 4}}>
                    {pedido && pedido.id &&
                        <PDFDownloadLink
                            document={<Pdf_Recibo logo={logo} datos={pedido} pago={pago}/>}
                            fileName={"Recibo de compra "}
                            style={{textDecoration: "none"}}>
                            <Button
                            >Descargar Recibo de Compra</Button>
                        </PDFDownloadLink>
                    }
                </Grid>


            </Grid>

        </Grid>
    )

}
export default Recibo_Portada

const items = [
    'Herencia Familiar Auténtica',
    'Expansión Global Estratégica',
    'Supervisión Maestra en Origen',
    'Trazabilidad Tecnológica Garantizada',
    'Conexión Profunda con la Tierra Oaxaqueña',
    'Digitalización y Profesionalización',
    'Compromiso con la Excelencia Artesanal',
    'Logística Eficiente y Puntual'
]